// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/index.less
// module id = 2006
// module chunks = 0